import {WindowService} from "../../../services/WindowService";

export default {
    minimized: WindowService.width() <= WindowService.breakpoints.lg,
    menu: {
        open: false,
    },
    language: {
        value: 'en',
        name: 'English'
    },
    suppliers: {
        loading: false,
        error: false,
        items: []
    },
    supplier: undefined,
    productTypes: {
        loading: false,
        error: false,
        items: []
    },
    productType: undefined
}



// WEBPACK FOOTER //
// ./src/store/modules/nav/state.js